<template>
  <div>
    <div v-if="isNoResult===false" class="hanoi-live one-city--xosotv">
      <table class="kqmb extendable">
        <tbody>
          <tr class="madb">
            <td colspan="12" style="padding: 10px 0px; background-color: #B40500; color: #FFFFFF;">
              <strong>HANOI EXPRO</strong>
            </td>
          </tr>
          <tr class="db">
            <td class="txt-giai" style="color:inherit;">Đặc biệt</td>
            <td colspan="12" class="number">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_1st" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr class="bg_f6">
            <td class="txt-giai">Giải nhất</td>
            <td colspan="12" class="number">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_2nd" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr>
            <td class="txt-giai">Giải nhì</td>
            <td colspan="6" class="number">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td colspan="6" class="number">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr class="giai3 bg_ef">
            <td class="txt-giai" rowspan="2">Giải ba</td>
            <td class="number" colspan="4">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr class="bg_ef">
            <td class="number" colspan="4">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_5" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_6" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr>
            <td class="txt-giai">Giải tư</td>
            <td class="number" colspan="3">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_5th_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="3">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_5th_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="3">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_5th_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="3">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_5th_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr class="giai5 bg_ef">
            <td class="txt-giai" rowspan="2">Giải năm</td>
            <td class="number" colspan="4">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr class="bg_ef">
            <td class="number" colspan="4">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_5" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_6" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr>
            <td class="txt-giai">Giải sáu</td>
            <td class="number" colspan="4">
              <ShowNumbers length="3" :results="resultNumbers" result-key="prize_7th_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="3" :results="resultNumbers" result-key="prize_7th_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="4">
              <ShowNumbers length="3" :results="resultNumbers" result-key="prize_7th_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
          <tr class="db bg_ef">
            <td class="txt-giai" style="color:inherit;">Giải bảy</td>
            <td class="number" colspan="3">
              <ShowNumbers length="2" :results="resultNumbers" result-key="prize_2digits_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="3">
              <ShowNumbers length="2" :results="resultNumbers" result-key="prize_2digits_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="3">
              <ShowNumbers length="2" :results="resultNumbers" result-key="prize_2digits_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
            <td class="number" colspan="3">
              <ShowNumbers length="2" :results="resultNumbers" result-key="prize_2digits_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
            </td>
          </tr>
        </tbody>
        <!--<tfoot>
          <tr>
            <td colspan="13" style="padding: 0">
              <img src="/assets/images/ex-footer.png" style="width: 100%;">
            </td>
          </tr>
        </tfoot>-->
      </table>
    </div>
  </div>
</template>
<script>
import { slotItems } from '@/configs/slot.config.js'
import LottoService from '@/services/lottoService.js'

import ShowNumbers from './ShowNumbers.vue'

export default {
  name: 'ResultBox',
  components: {
    ShowNumbers
  },
  data() {
    return {
      resultDate: null,
      currentResult: null,
      distance: 20, // ระยะห่างของการออกแต่ล่ะเลข (วินาที)
      slotCounting: null,
      IntervalReload: null,
      setTimeoutToshow: null,
      updateTime: null,
      isNoResult: false
    }
  },
  computed: {
    checkUpdate() {
      return `${this.startSpin}-${this.startShow}-${this.prize1st}-${this.prize2nd}-${this.endTime}-${this.slotCounting}`
    },
    drawDate() {
      if (!this.currentResult)
        return '-'

      let date = this.$moment(this.currentResult.lotto_date)
      return date.format("DD/MM/YYYY")
    },
    resultNumbers() {
      if (this.currentResult !== null) {
        return this.currentResult.results
      } else {
        return null
      }
    },
    updateCode() {
      return this.updateTime
    },
    startSpin() {
      if (this.currentResult !== null) {
        return this.currentResult.start_spin
      }
      return null
    },
    startShow() {
      if (this.currentResult !== null && this.currentResult.show_2nd) {
        return this.currentResult.show_2nd
      }
      return null
    },
    endTime() {
      if (this.currentResult !== null && this.currentResult.show_1st) {
        return this.currentResult.show_1st
      }
      return null
    },
  },
  watch: {
    checkUpdate() {
      this.updateTime = new Date().getTime()
      this.calProcess()
    }
  },
  methods: {
    getResult() {
      LottoService.getResult(this.resultDate).then((response)=>{
        if (response.status === 'success') {
          this.currentResult = response.data
        }else{
          this.isNoResult = true
        }
      })
    },
    calProcess() {
      console.log('calProcess...')
      if(this.currentResult.show_2nd) {
        if(this.endTime!==null && this.$moment().isAfter(this.endTime)) {
          this.slotCounting = slotItems[slotItems.length - 1]
          //this.updateTime = new Date().getTime()
        }else
        // ยังไม่ถึงเวลาแสดงค่าแรก
        if(this.$moment().isBefore(this.currentResult.show_2nd)) {
          this.slotCounting = null
          let diff = this.$moment(this.currentResult.show_2nd).diff(this.$moment(), 'milliseconds')
          clearTimeout(this.setTimeoutToshow)
          this.setTimeoutToshow = setTimeout(() => {
            this.calProcess()
          }, diff)
        // ถึงเวลาแสดงค่าแรก
        }else{
          // ระยะเวลาหลังจากแสดงค่าแรก
          let diff = this.$moment().diff(this.$moment(this.currentResult.show_2nd), 'milliseconds')
          let slotIndex = Math.floor(Math.abs(diff) / (this.distance*1000))
          //this.updateTime = new Date().getTime()
          if (slotIndex < slotItems.length) {
            this.slotCounting = slotItems[slotIndex]
          } else {
            this.slotCounting = slotItems[slotItems.length - 1]
          }
        }
      }
    }
  },
  created() {
    this.resultDate = this.$route.params.pathDate
    this.getResult()
    this.IntervalReload = setInterval(() => {
      this.getResult()
    }, 45000)
  },
  beforeDestroy() {
    clearTimeout(this.setTimeoutToshow)
    clearInterval(this.IntervalReload)
  }
}
</script>
<style lang="scss" scoped>
.hanoi-live {
  margin-bottom: 10px;
  background-color: #FFFFFF;

  table {
    width: 100%;
    border: 1px solid #B40500;
    border-collapse: collapse;
    border-spacing: 0;
    margin: 0;

    tr {
      &.bg_f6, &.bg_ef {
        background-color: #efefef;
      }
      &.db {
        td {
          color: #e80000;
        }
      }
    }

    td {
      font-size: 16px;
      vertical-align: middle;
      text-align: center;
      border: 1px solid #B40500;
      padding: 8px 1px;

      &.txt-giai {
        width: 70px;
        min-width: 60px;
      }
      &.number {
        font-size: 22px;
        letter-spacing: 1px;
      }
    }
  }
}
</style>
